import React from "react";
import { Routes, Route } from "react-router-dom";
import Filter from "../pages/filter";
import PrintPdf from "../pages/printpdf";
import Signup from "../pages/signup";
import Login from "../pages/login";
import Profile from "../pages/profile";
import SharedList from "../pages/sharedlist";
import Updatelist from "../pages/update";
import Home from "../pages/home";
import About from "../pages/about";
import WhatsNew from "../pages/whatsNew";
import TermsAndConditions from "../pages/termsAndConditions";
import AdsPage from "../pages/ads";
import Contact from "../pages/contact";
import ApRankPredictor from "../pages/apRankPredictor";
import TsRankPredictor from "../pages/tsRankPredictor";
import ResetPassword from "../pages/resetPassword";
import RankPredictor from "../pages/rankPredictor";
import FAQ from "../components/homePageComponents/faq";
import ReviewReport from "../pages/reviewReport";
import Feedback from "../pages/feedback";
import NewBranches from "../pages/newBranches";
import AP2024Colleges from "../pages/ap_2024_colleges";
import AP2024Branches from "../pages/ap_2024_branches";
import CounsellingResult from "../pages/counsellingResult";
import AP2025EnggColleges from "../pages/ap_2025_engg_colleges";
import AP2025PharmacyColleges from "../pages/ap_2025_pharmacy_colleges";
import CreateAP2025EnggList from "../pages/create_ap_2025_engg_list";
import CreateAP2025PharmacyList from "../pages/create_ap_2025_phar_list";
import UpdateAP2025Lists from "../pages/update_2025_ap_lists";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/filter" element={<Filter />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/printpdf" element={<PrintPdf />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/update" element={<Updatelist />} />
      <Route path="/shared/:userId/:favoriteId" element={<SharedList />} />
      {/* <Route path="/aprankpredictor" element={<ApRankPredictor />} /> */}
      {/* <Route path="tsrankpredictor" element={<TsRankPredictor />} /> */}
      <Route path="/about" element={<About />} />
      <Route path="/whatsnew" element={<WhatsNew />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/ads" element={<AdsPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      {/* <Route path="/rankpredictor" element={<RankPredictor />} /> */}
      <Route path="/faqs" element={<FAQ />} />
      <Route path="/review-report" element={<ReviewReport />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/new-branches-2024" element={<NewBranches/>} />
      <Route path="/ap-2024-colleges" element={<AP2024Colleges/>} />
      <Route path="/ap-2024-branches" element={<AP2024Branches/>} />
      <Route path="/counselling-result" element={<CounsellingResult />} />
      <Route path="/ap-2025-engg-colleges" element={<AP2025EnggColleges />} />
      <Route path="/ap-2025-pharmacy-colleges" element={<AP2025PharmacyColleges />} />
      <Route path="/create-ap-2025-engg-list" element={<CreateAP2025EnggList />} />
      <Route path="/create-ap-2025-phar-list" element={<CreateAP2025PharmacyList />} />
      <Route path="/update-2025-ap-list" element={<UpdateAP2025Lists />} />
      {/* Add more routes as needed */}
    </Routes>
  );
};

export default AppRoutes;
